import script from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&setup=true&lang=js"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=32d074a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d074a2"]])

export default __exports__